import React from "react";
import "./Home.css";

const Vision = () => {
  return (
    <section className="vision-section text-center">
      <div className="vision-container">
        <h2 className="vision-title">Our Vision</h2>
        <p className="vision-description">
          <span className="quote-mark">“</span>
          At Ustadistan Tutor Academy, we envision a future where quality
          education is accessible to every learner anytime, anywhere. Whether
          online, onsite, or at home, our mission is to bridge the gap between
          students and exceptional educators, fostering academic excellence,
          personal growth, and a lifelong love for learning. We aim to be the
          most trusted and innovative tutoring platform in the region,
          empowering students of all ages and backgrounds to reach their full
          potential. By blending modern technology with personalized teaching,
          Ustadistan is committed to transforming traditional tutoring into a
          dynamic, engaging, and results-driven experience.
          <span className="quote-mark">”</span>
        </p>
      </div>
    </section>
  );
};

export default Vision;
